import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CommonService } from '../common/services/common.service';

@Injectable()
export class FaqService {

  constructor(private http: HttpClient, private _commonService: CommonService ) { }

  sendFaqRequest(email, message){
    const params = {
      email: email,
      Message: message
    };
    const headers: HttpHeaders = new HttpHeaders();
    return this.http.post(this._commonService.baseUrl + 'sendFaqRequest', params, { headers, observe: 'response' });
  }

}
